export class DigitalRecipient {
  constructor (
    { firstName, lastName, email } = {
      firstName: '',
      lastName: '',
      email: ''
    }
  ) {
    this.firstName = firstName
    this.lastName = lastName
    this.email = email
  }
}
